import React, { useEffect, useState } from "react";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { useDispatch, useSelector } from "react-redux";
import { viewImage } from "../CommonUtils/viewImage";
import CommonStepperSection from "./Reports/CommonStepperSection";

export default function AfflDegreeReport() {
    const collCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const userId = sessionStorage.getItem('user_id');
    const acYear = sessionStorage.getItem('ac_year');
    const result = (userId.startsWith("affl") || userId.startsWith("reg") || ["apsche_affl", "prlsecy_he"].includes(userId)) ? collCode : userId;
    const dispatch = useDispatch();


    const [data, setData] = useState([]);
    function GetOverAllData() {
        let affilCatgurl = config.url.API_URL + "getoveralldata/" + result;
        CommonAxiosGet(affilCatgurl, dispatch).then((resAyaffilCatgoty) => {
            if (resAyaffilCatgoty?.data !== undefined) {
                setData(resAyaffilCatgoty?.data?.submitcount)
            }
            else {
                setData([])
            }
        })
    }



    //changing structure 

    const [statusObj, setStatusObj] = useState({});
    const [currentStep, setCurrentStep] = useState(0);
    const [allDone, setAllDone] = useState(false);

    const fieldToStepIndex = {
        clgdetails: 0, bldblocks: 1, instarea: 2, tch: 3,
        labarea: 4, labmap: 5, submission: 6
    };

    const stepTitles = [
        "college Approval Details", "Building Blocks", "Instructional Area",
        "Teaching Staff", "Lab Area", "Lab course Mapping", "Final Submission"
    ];

    function computeCurrentStep(status) {
        // Find the first step that's not done, otherwise mark all
        for (const [field, idx] of Object.entries(fieldToStepIndex)) {
            if (status[field] !== 'Done') {
                return idx + 1;
            }
        }
        return stepTitles.length;
    }



    function isAllDone(status) {
        return Object.keys(fieldToStepIndex).every(field => status[field] === 'Done');
    }


    function CollegeSubmissiontatus() {
        CommonAxiosGet(`${config.url.API_URL}getclgRegStatus`).then(res => {
            if (res?.data?.scode === '01' && res.data.clgStatus?.[0]) {
                const obj = res.data.clgStatus[0];
                setStatusObj(obj);
                setCurrentStep(computeCurrentStep(obj));
                setAllDone(isAllDone(obj));
            } else {
                setStatusObj({});
                setCurrentStep(0);
                setAllDone(false);

            }
        }).catch(() => {
            setStatusObj({});
            setCurrentStep(0);
        });
    }


    function GetPdf() {
        let payload = {}
        let url = config.url.API_URL + `getdegreepdf/${result}/${acYear}`
        CommonAxiosPost(url, payload, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }

    useEffect(() => {
        CollegeSubmissiontatus();
        GetOverAllData();

    }, [])

    return (
        // <>
        //     <CommonFormHeading heading="College Submission Pdf" />
        //     <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" >
        //         <div className="inner-herbpage-service-title-sub pt-0 mb-3 d-flex align-items-center">
        //             <h1 className='mb-0'>
        //                 College Name: <span>{statusObj?.inst_name}</span>
        //             </h1>
        //             <h1 className='mb-0 ms-4'>
        //                 College Code: <span>{statusObj?.coll_code}</span>
        //             </h1>
        //         </div>
        //         <bie.Container fluid className="pt-5 d-flex justify-content-center">
        //             <bie.Row>
        //                 <bie.Col md={12} className="px-4">
        //                     <div className="vertical-stepper" >
        //                         {stepTitles.map((title, i) => {
        //                             const stepIndex = i + 1;
        //                             const fieldName = Object.keys(fieldToStepIndex)
        //                                 .find(key => fieldToStepIndex[key] === i);
        //                             const val = statusObj[fieldName];
        //                             const isDone = val === 'Done';
        //                             const isActive = stepIndex === currentStep;
        //                             return (
        //                                 <div key={i} className="stepper-step d-flex mb-4">
        //                                     <div className="icon-column d-flex flex-column align-items-center">
        //                                         <div className={`step-circle ${isDone ? 'completed' : isActive ? 'active' : 'pending'}`}>
        //                                             {isDone ? <FaCheck /> : stepIndex}
        //                                         </div>
        //                                         {i < stepTitles.length - 1 && (
        //                                             <div className={`step-line ${stepIndex < currentStep ? 'line-completed' : ''}`}></div>
        //                                         )}
        //                                     </div>
        //                                     <button type='button'
        //                                         className="step-text ps-3"
        //                                         onClick={() => setCurrentStep(stepIndex)}
        //                                         style={{ cursor: 'pointer' }}
        //                                     >
        //                                         <div className={`step-label ${isDone ? 'label-done' : ''} ${isActive ? 'active-label' : ''}`}>
        //                                             {title}
        //                                         </div>
        //                                         <div className="step-status mt-1">
        //                                             <bie.Badge bg={isDone ? "success" : "danger"}>
        //                                                 {isDone
        //                                                     ? <><FaCheck className="me-1" /> Done</>
        //                                                     : <><FaTimes className="me-1" /> Not Done</>}
        //                                             </bie.Badge>

        //                                         </div>

        //                                     </button>

        //                                 </div>

        //                             );
        //                         })}
        //                     </div>
        //                 </bie.Col>
        //                 <center>
        //                     {allDone && (
        //                         <button
        //                             type="button"
        //                             className="btn btn-sm affl-print me-2"
        //                             onClick={GetPdf}>
        //                             click here to download  &emsp;<FaRegFilePdf size={20} />
        //                         </button>
        //                     )}
        //                 </center>

        //             </bie.Row>
        //         </bie.Container>
        //     </bie.Container>
        // </>

        <CommonStepperSection
            heading="College Submission Pdf"
            statusObj={statusObj}
            stepTitles={stepTitles}
            fieldToStepIndex={fieldToStepIndex}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            allDone={allDone}
            GetPdf={GetPdf}
        />

    )
}